export const LOADING_AREAS = 'LOADING_AREAS';
export const GET_AREAS = 'GET_AREAS';
export const SAVE_LOADING_AREAS = 'SAVE_LOADING_AREAS';

export const FORM_FAIL = "FORM_FAIL";
export const AREAS_FAIL = "AREAS_FAIL";
